
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Audit from "./components/Audit.jsx";
import CyberSecurity from "./components/CyberSecurity.jsx";
import AILandingPage from "./components/AILandingPage.jsx";
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";

function App() {
  const location = useLocation();

  // Get the current page name
  const currentView =
    location.pathname.split("/").filter(Boolean).pop() || "audit";

  // Change page title and scroll to top
  useEffect(() => {
    switch (currentView) {
      case "cyber-security":
        document.title = "Cyber Security | Peopleclick";
        break;

      case "ai-landing":
        document.title = "Digital Marketing | Peopleclick";
        break;

      case "audit":
        document.title =
          "Compliance Audits, Reimagined — Audit.AI | Peopleclick";
        break;

      default:
        document.title = "Peopleclick";
        break;
    }

    window.scrollTo(0, 0);
  }, [currentView]);

  return (
    <>
      <Navbar currentView={currentView} />
      <Routes>

        {/* Audit */}
        <Route
          path="/audit"
          element={<Audit />}
        />

        {/* Cyber Security */}
        <Route
          path="/cyber-security"
          element={<CyberSecurity />}
        />

        {/* AI / Digital Marketing */}
        <Route
          path="/ai-landing"
          element={<AILandingPage />}
        />

        {/* Default */}
        <Route
          path="/"
          element={<Navigate to="/audit" replace />}
        />

        {/* Unknown URL */}
        <Route
          path="*"
          element={<Navigate to="/audit" replace />}
        />

      </Routes>
      <Footer />
    </>
  );
}

export default App;

